export default __webpack_public_path__ + "static/media/print.d0e77813.ico";